"use client";

import { IntlProvider as ReactIntlProvider } from "react-intl";

export function IntlProvider({ children }: { children: React.ReactNode }) {
  return (
    // Dummy react-intl provider to probably compile @wuilt/section-elements
    // @ts-ignore
    <ReactIntlProvider locale="en" messages={{}} defaultLocale="en">
      <>{children}</>
    </ReactIntlProvider>
  );
}
